import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { SearchContainerComponent } from '../search-container/search-container.component';
import { DataTableSchema } from '../../model/dynamic-data-table.model';
import { DynamicFormArray, FieldSelectedValue, FormFieldConfig, Props } from '../../model/form.model';
import { DynamicDataTableComponent } from "../dynamic-data-table/dynamic-data-table.component";
import { BreadcrumsComponent } from "../../components/breadcrums/breadcrums.component";
import { API_STATUS, ERROR_RESPONSE, SearchConfig } from '../../model/api.model';
import { DownloadButtonComponent } from '../../components/download-button/download-button.component';
import { CommonUtils } from '../../utils/common.utils';
import { GlobalApiService } from '../../services/global-api.service';
import { ExcelExportService } from '../../services/excel-export.service';
import { SpinnerComponent } from '../spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../services/common.service';
import { FieldNames } from '../../model/form-fields.model';


@Component({
  selector: 'filter-list-container',
  standalone: true,
  imports: [SearchContainerComponent, DynamicDataTableComponent, CommonModule, BreadcrumsComponent, DownloadButtonComponent, SpinnerComponent],
  templateUrl: './filter-list-container.component.html',
  styleUrl: './filter-list-container.component.scss'
})
export class FilterListContainerComponent implements OnInit ,OnDestroy { 
  @Input() DataTableSchema!: DataTableSchema;
  @Input() filterSchema!: DynamicFormArray;
  @Input() dataInput?: Array<any>;
  @Input() dataTransform?: (response: any) => any[];
  @Input() props!: Props;
  @Input() forSection?: boolean = false;
  @Input() apiConfig!: SearchConfig;
  @Input() elementId!: string;
  @Input() groupType!: any;
  @Input() globalFilterFields!: Array<any>
  @Input() onLoadFetch = false;
  public beginRender = false;
  private readonly commonUtils = inject(CommonUtils);
  private readonly globalService = inject(GlobalApiService);
  private readonly commonService = inject(CommonService);
  private readonly exportService = inject(ExcelExportService);
  private globalpayloadSubject!: any;
  private globalpayload: any;
  public spinnerName!: string;
  public globalTitleFields: any = {}
  private latestFetchRequestId = 0;

  //  ngOnChanges(changes: SimpleChanges): void {
  //   this.DataTableSchema.dataSource=[];
  // }

  ngOnInit() {
    this.beginRender = true;
    if (this.forSection) {
      this.spinnerName = this.elementId;
      this.initializeSectionTable()
    }
    if (this.onLoadFetch && !this.globalpayload) {
      this.fetchDataAndUpdateData()
    }
  }
  ngOnDestroy() {
    this.globalpayloadSubject?.unsubscribe()
  }
  initializeSectionTable() {
    this.updateFilterFields()
    this.updateTitle();
  }
  updateTitle(field?: FormFieldConfig) {
    if(this.DataTableSchema['titleSchema']){
      const titleConfig = {
        titleSchema: this.DataTableSchema['titleSchema'],
        filterFields: this.filterSchema['FieldsArray'],
        globalTitleFields: this.globalTitleFields ?? {}
      }
      const titleResult = this.commonUtils.updateTitle(titleConfig, field);
      this.DataTableSchema['title'] = titleResult['title'];
    }
  }
  async updateFilterFields() {
    if (this.filterSchema.globalPayloadSubject) {
      this.globalpayloadSubject = this.filterSchema.globalPayloadSubject.subscribe(globalPayload => {
        if (this.globalFilterFields.includes(globalPayload['FieldName'])) {
          this.globalTitleFields = globalPayload?.Value?.title ?? {}
          if (globalPayload?.Value?.body) {
            this.globalpayload = structuredClone(globalPayload['Value']['body']);
            this.updateTitle()
            this.updatePayloadAndFetch(this.globalpayload)
          } 
        }
      })
    }
    if (!this.filterSchema?.FieldsArray) {
      return;
    }
    this.filterSchema.FieldsArray.forEach(field => {
      this.commonUtils.setDefaultValueForOptionsField(field);
    })
    if (!this.filterSchema.onControlValueChanged) {
      this.filterSchema.onControlValueChanged = this.filterFieldOnChange;
    }
    this.updateTitle();
  }
  filterFieldOnChange = (event: FieldSelectedValue) => {
    let selectedField: FormFieldConfig;
    let postParams = this.globalpayload ?? {};
    event?.FieldArray?.forEach(field => {
      if (field['isDependentOn'] === event['FieldName']) {
        field['selectedValue'] = '';
      } else if (field['fieldName'] === event['FieldName']) {
        selectedField = field;
        this.updateTitle(selectedField)
      }
      if (field['selectedValue'] && field['selectedValue'] !== null && field['selectedValue'] !== '') {
        postParams[field['fieldName']] = field['selectedValue']
      }
    })
    if (event?.FieldArray?.length) {
      const hasNonEmptyField = event.FieldArray.some(field => field.selectedValue && field.selectedValue !== null && field.selectedValue !== '' && field.selectedValue.length > 0);
      const monthField = event.FieldArray.find(field => field.fieldName === FieldNames.Month && field.multiple && field.defaultValue && field.defaultValue.length > 0);
      if (!hasNonEmptyField && monthField) {
        monthField.isDefaultSet = true;
        monthField.selectedValue = Array.isArray(monthField.defaultValue) ? monthField.defaultValue : [monthField.defaultValue];
        if (monthField.payloadInfo) {
          postParams = {
            ...postParams,
            ...monthField.payloadInfo
          };
        }
        postParams[monthField.fieldName] = monthField.selectedValue;
      }
    }
    this.fetchDataAndUpdateData(postParams)
  }
  updatePayloadAndFetch(globalPayload: any) {
    const postParams = {
      ...globalPayload
    };
    if (this.filterSchema?.FieldsArray) {
      this.filterSchema?.FieldsArray.forEach(filterField => {
        if (filterField['selectedValue'] && filterField['selectedValue'] !== null && filterField['selectedValue'] !== '') {
          postParams[filterField['fieldName']] = filterField['selectedValue']
        }
      })
    }
    this.fetchDataAndUpdateData(postParams)
  }
  fetchDataAndUpdateData(postParam?: any) {
    this.DataTableSchema.isLoading = true;
    const requestId = ++this.latestFetchRequestId;
    if (this.apiConfig) {
      const fetchParams: SearchConfig = {
          ...this.apiConfig,
        }
      if (this.DataTableSchema?.dataSource) {
        if (this.DataTableSchema.dataSource?.data) {
          this.DataTableSchema.dataSource.data = []
        } else {
          this.DataTableSchema.dataSource = []
        }
      }
      const originalBody = this.apiConfig.body || {};
      fetchParams['body'] ??= {};
      fetchParams['body'] = { ...originalBody, ...postParam };
      const urlPath = this.apiConfig['urlPath'] ?? '';
      return this.commonService.getDataFromDataSource(fetchParams, urlPath).then(response => {
        if (requestId !== this.latestFetchRequestId) {
          return;
        }
        if (response['status'] === API_STATUS['Success']) {
          let rows = response['result'];
          if (this.dataTransform && typeof this.dataTransform === 'function') {
            try {
              rows = this.dataTransform(response['result']);
            } catch (err) {
              console.info('dataTransform error', err);
            }
          }
          this.DataTableSchema['dataSource'] = rows;
        } else {
          this.commonUtils.showMatSnackBar(ERROR_RESPONSE['noDataFound'])
          this.DataTableSchema['dataSource'] = response['result'];
        }
        this.DataTableSchema.isLoading = false;
      }).catch(err => {
        if (requestId !== this.latestFetchRequestId) {
          return;
        }
        console.info('Error :-', err)  
        this.commonUtils.showMatSnackBar(ERROR_RESPONSE['noDataFound'])
        this.DataTableSchema.isLoading = false;
      });
    } else {      
      this.DataTableSchema.isLoading = false;
      return Promise.reject(new Error('API Config issue.'));
    }
  }
  exportTableData() {
    let data: Array<any> = this.DataTableSchema['dataSource'];
    if (data.length <= 0) {
      this.commonUtils.showMatSnackBar('Export Failed - No Data Found')
      return;
    }
    const exportConfig: any = this.DataTableSchema?.exportConfig;
    if (exportConfig) {
      const sortedData = this.commonUtils.clientSideSort(this.DataTableSchema['dataSource'], this.DataTableSchema.activeSorts);
      data = structuredClone(this.commonUtils.formatExcelData(exportConfig, sortedData, this.filterSchema)) ?? [];
      const fileName = exportConfig.fileName ?? '';
      const description = exportConfig.descriptions ?? [];
      this.exportService.exportAsExcelFile(data, fileName, description)
    }
  }
}
